import { Component, Injector, Input } from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { NotificationService } from '../../core/services/notification.service';
import { LeadsService } from '../../shared/services/leads.service';

@Component({
	selector: 'lead-postpone-dialog',
	templateUrl: './lead-postpone-dialog.component.html',
	styleUrls: ['./lead-postpone-dialog.component.scss'],
})
export class LeadPostponeDialogComponent {
	@Input() leadId: number;
	@Input() onSuccess: () => void;

	stoppedUntil: Date;
	minDate: Date = new Date(new Date().getTime() + 5 * 60000);
	stoppedUntilRequired = true;

	constructor(
		private injector: Injector,
		private dataService: LeadsService,
		private notificationService: NotificationService
	) {}

	confirm(): void {
		if (!this.leadId) {
			this.close();
			return;
		}
		if (!this.stoppedUntil) {
			this.notificationService.warning({ title: 'Отложить', message: 'Укажите дату и время' });
			return;
		}
		if (this.stoppedUntil.getTime() <= Date.now()) {
			this.notificationService.warning({ title: 'Отложить', message: 'Дата и время должны быть в будущем' });
			return;
		}

		const iso = this.stoppedUntil.toISOString();
		this.dataService.postpone(this.leadId, iso).subscribe(x => {
			if (x.isSuccessful) {
				this.stoppedUntil = null;
				if (this.onSuccess) {
					this.onSuccess();
				}
				this.close();
			}
		});
	}

	cancel(): void {
		this.close();
	}

	private close(): void {
		this.injector.get(DialogRef).close();
	}
}
